export default "__VITE_ASSET__7ec2129e__"